import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { GradualSpacing } from '../../effects/GradualSpacing';

export interface SectionHeaderProps {
    title: string;
}

function SectionHeader({ title }: SectionHeaderProps) {
    const time = useMemo(() => {
        const now = DateTime.now();
        const format = 'h:mm a';

        return now.toFormat(format).toUpperCase();
    }, []);

    return (
        <div
            style={{
                position: 'absolute',
                padding: '2.6vh', // 50
                textTransform: 'uppercase',
                fontSize: '1.67vh', // 32
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100vw',
                color: 'white',
            }}
        >
            <div>
                <GradualSpacing
                    text={title}
                    ignoreLinebreaks
                />
            </div>

            <div>
                {time ? <GradualSpacing text={time} /> : null}
            </div>
        </div>
    );
}

export default SectionHeader;
